import {
  Home,
  Monitor,
  Settings,
  MapPin,
  Activity,
  Compass,
  Server,
  CloudOff,
  Database,
  Calendar,
  Camera,
  Briefcase,
  Clipboard,
  UserCheck,
} from "react-feather";

export const MENUITEMS = [
  {
    title: "Dashboard",
    icon: Home,
    type: "link",
    path: "/dashboard",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Jabatan / Unit",
    icon: Briefcase,
    type: "link",
    path: "/departments",
    active: false,
  },
  {
    title: "Pegawai",
    icon: UserCheck,
    type: "link",
    path: "/officers",
    active: false,
  },
  {
    title: "Template Kerja",
    icon: Clipboard,
    type: "link",
    path: "/workflow",
    active: false,
  },
  {
    title: "Kehadiran Lewat",
    icon: Compass,
    type: "link",
    path: "/lateComer",
    active: false,
  },
  {
    title: "Pengumuman",
    icon: Activity,
    type: "link",
    path: "/bulletin",
    active: false,
  },
  {
    title: "Lokasi Check-In",
    icon: MapPin,
    type: "link",
    path: "/gate",
    active: false,
  },
  {
    title: "Rekod Lapangan",
    icon: Camera,
    type: "link",
    path: "/customAttendance",
    active: false,
  },
  {
    title: "Cuti Umum / Kelepasan",
    icon: Calendar,
    type: "link",
    path: "/schoolHolidayConfig",
    active: false,
  },
  {
    title: "Tetapan Agensi",
    icon: Server,
    type: "link",
    path: "/schoolConfiguration",
    active: false,
  },
  {
    title: "Muat Turun Kehadiran",
    icon: Database,
    type: "link",
    path: "/downloadAttendance",
    active: false,
  },
  {
    title: "Log Sistem",
    icon: CloudOff,
    type: "link",
    path: "/auditLog",
    active: false,
  },
  {
    title: "Pengguna Sistem",
    icon: Monitor,
    type: "sub",
    active: false,
    children: [
      {
        path: "/portalUser",
        type: "link",
        title: "Pengguna Portal",
      },
    ],
  },
  {
    title: "Tetapan Sistem",
    icon: Settings,
    type: "link",
    path: "/settings",
    active: false,
  },
];